(function() {
  if (window.__cartUpsellBound) return;
  window.__cartUpsellBound = true;
  function formatMoney(cents) {
    return String.fromCharCode(36) + (cents / 100).toFixed(2);
  }
  function showMessage(container, text) {
    if (!container) return;
    var message = container.querySelector('[data-cart-upsell-message]');
    if (message) {
      message.textContent = text;
      message.style.display = 'block';
    }
  }
  function updateCountAndTotals(cart) {
    var bubbles = document.querySelectorAll('.cart-count-bubble span');
    bubbles.forEach(function(span) { span.textContent = cart.item_count; });
    var countElements = document.querySelectorAll('.cart-count-bubble');
    countElements.forEach(function(el) {
      if (cart.item_count > 0) { el.classList.remove('hidden'); } else { el.classList.add('hidden'); }
    });
    var totals = document.querySelectorAll('.totals__total-value');
    totals.forEach(function(el) { el.textContent = formatMoney(cart.total_price); });
    var drawer = document.querySelector('cart-drawer');
    if (drawer) {
      if (cart.item_count > 0) { drawer.classList.remove('is-empty'); } else { drawer.classList.add('is-empty'); }
    }
  }
  function getSectionInnerHTML(html, selector) {
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var el = doc.querySelector(selector);
    return el ? el.innerHTML : null;
  }
  function renderSections() {
    var sections = [
      { id: 'main-cart-items', selector: '.js-contents', target: '#main-cart-items .js-contents' },
      { id: 'main-cart-footer', selector: '.js-contents', target: '.cart__footer .js-contents' },
      { id: 'cart-drawer', selector: '#CartDrawer', target: '#CartDrawer' },
      { id: 'cart-icon-bubble', selector: '.shopify-section', target: '#cart-icon-bubble' }
    ];
    var ids = sections.map(function(s) { return s.id; }).join(',');
    return fetch('/?sections=' + ids, { headers: { 'Accept': 'application/json' } })
      .then(function(response) { return response.json(); })
      .then(function(data) {
        sections.forEach(function(section) {
          if (!data[section.id]) return;
          var target = document.querySelector(section.target);
          if (!target) return;
          var inner = getSectionInnerHTML(data[section.id], section.selector);
          if (inner !== null) { target.innerHTML = inner; } var upsellBlocks = document.querySelectorAll('.cart-upsell'); if (upsellBlocks.length) { var freshUpsell = null; ['main-cart-footer', 'cart-drawer'].forEach(function(id) { if (!data[id]) return; var freshDoc = new DOMParser().parseFromString(data[id], 'text/html'); var fresh = freshDoc.querySelector('.cart-upsell'); if (fresh) freshUpsell = fresh; }); upsellBlocks.forEach(function(block) { if (freshUpsell) { block.outerHTML = freshUpsell.outerHTML; } else { block.remove(); } }); }
        });
      })
      .catch(function() {});
  }
  document.addEventListener('click', function(event) {
    var button = event.target.closest ? event.target.closest('.cart-upsell__button') : null;
    if (!button || button.disabled) return;
    event.preventDefault();
    event.stopPropagation();
    var variantId = button.getAttribute('data-variant-id');
    if (!variantId) return;
    var originalText = button.textContent;
    var container = button.closest('.cart-upsell');
    button.disabled = true;
    button.textContent = 'Adding...';
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: parseInt(variantId, 10), quantity: 1 })
    })
      .then(function(response) {
        if (!response.ok) {
          return response.json().then(function(data) {
            throw new Error(data.description || 'Could not add to cart.');
          }).catch(function(err) {
            if (err && err.message) throw err;
            throw new Error('Could not add to cart.');
          });
        }
        return response.json();
      })
      .then(function() {
        button.textContent = 'Added';
        setTimeout(function() {
          renderSections().then(function() {
            return fetch('/cart.js', { headers: { 'Accept': 'application/json' } });
          }).then(function(response) { return response.json(); })
          .then(function(cart) { updateCountAndTotals(cart); if (button.isConnected) { button.disabled = false; button.textContent = originalText; } })
          .catch(function() {});
        }, 700);
      })
      .catch(function(err) {
        button.disabled = false;
        button.textContent = originalText;
        showMessage(container, (err && err.message) || 'Could not add to cart. Please try again, or view Beard Oil.');
      });
  });
  // refresh upsell after any cart change
  // theme controls use a cart fetch but do not re-render this block
  // so watch those fetches and reuse the same refresh an upsell add uses
  // adds wait longer than the upsell 700 ms refresh
  var cutimer=null;
  function curefresh(d){if(cutimer)clearTimeout(cutimer);cutimer=setTimeout(function(){renderSections();},d);}
  function cuis(url){if(!url)return false;url=url+'';return url.indexOf('/cart/change')>-1||url.indexOf('/cart/update')>-1||url.indexOf('/cart/clear')>-1||url.indexOf('/cart/add')>-1;}
  if(!window.cuwatch&&window.fetch){window.cuwatch=true;var cufetch=window.fetch;window.fetch=function(input,init){var url=typeof input==='string'?input:(input&&input.url);var is=cuis(url);var d=url&&url.indexOf('/cart/add')>-1?1000:250;return cufetch.apply(this,arguments).then(function(r){if(is)curefresh(d);return r;});};}
})();